export { default as profileIcon } from './profile-icon.svg'
export { default as cameraIcon } from './camera-icon.svg'
export { default as uploadIcon } from './upload-icon.svg'
export { default as closeIcon } from './close-icon.svg'
